/** Normalize draft list markers, including batched keyboard events; never received text. */
export function composerBullet(previous: string, next: string): string {
  if (next.length < previous.length) return next;
  let fence: string | null = null;
  return next.split('\n').map(line => {
    const marker = line.match(/^\s*(```|~~~)/)?.[1];
    if (marker) { if (!fence) fence = marker; else if (fence === marker) fence = null; return line; }
    return !fence && line.startsWith('- ') ? '•' + line.slice(1) : line;
  }).join('\n');
}
